module.exports = __webpack_public_path__ + "static/img/logo_QC.85cb82f4.png";